
import React, {useContext, useEffect, useState} from "react";
import {AuthContext} from "../../context";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import {TextField} from "@mui/material";
import Dialog from "@mui/material/Dialog";



export default function HourAdd(props) {
  const authContext = useContext(AuthContext);

  React.useEffect(()=>{
    //console.log("PROPS",props)
  },[props])

  return (

        <Box sx={{
          display: 'flex',
          gap: '8px',
          flexDirection: 'column',
          width: '500px',
          margin: '40px',
          height: '400px',
          overflowY: 'auto',
          alignItems: 'flex-start',
          justifyContent: 'flex-start'
        }}>
          <Typography variant="h4" color="textSecondary">Dettaglio ore per la WBS {props?.job?.code}</Typography>
        {
          Array.isArray(props?.data) && props?.data.length>0 && props?.data[props?.job?.index][props?.job?.jobID]?.hours.map((hour, index) => {
            return (
              <>
              <Box sx={{display: 'flex', gap: '8px', flexWrap: 'wrap', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', borderBottom: '1px solid #000', width: '500px', paddingBottom: '20px'}}>
               <center> <Typography variant="h6" color="textSecondary">({props?.job?.code}-{hour.code}) {hour.name}</Typography> </center>
                 <TextField
                    id={`sottojob-${props?.job?.index}`}
                    label="Ore"
                    type="number"
                    InputLabelProps={{
                      shrink: true,
                    }}
                    value={hour.hours}
                    onChange={(e) => {
                      hour.hours = e.target.value;
                      let appData = [...props?.data]
                      //console.log("appData", appData[props?.job?.index][props?.job?.jobID].hours[index].hours);
                      appData[props?.job?.index][props?.job?.jobID].hours[index].hours = e.target.value;
                      props?.setData((prevData) => prevData.map((item, i) => i === props?.job?.index ? appData[index] : item));
                    }}
                 />
              </Box>
              <hr></hr>
              </>

            )
          })
        }
        </Box>
  )
}